import { render, staticRenderFns } from "./SLItemCredit.vue?vue&type=template&id=346745b3&"
import script from "./SLItemCredit.vue?vue&type=script&lang=js&"
export * from "./SLItemCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports